import React from 'react';
import classNames from 'classnames';

export default ({ selected, callback, icon, value, mode }) => {
  return (
    <div
      className={classNames(
        'conference-operate-circle',
        { 'circle-btn-selected': selected },
        mode
      )}
      onClick={callback}
    >
      {icon && (
        <div>
          <i className={classNames('iconfont', 'btn-icon', icon)} />
        </div>
      )}
      {value &&
        value.map((item, i) => {
          return (
            <div
              key={i}
              className={classNames({
                'operate-circle-operate': isNaN(item),
                'operate-circle-min': 'min' === item
              })}
            >
              {item}
            </div>
          );
        })}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/CircleBtn.js